"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _Spinner = require("../Spinner");

var _Spinner2 = _interopRequireDefault(_Spinner);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SubmitButton = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(SubmitButton, _Component);

  function SubmitButton() {
    (0, _classCallCheck3.default)(this, SubmitButton);
    return (0, _possibleConstructorReturn3.default)(this, (SubmitButton.__proto__ || (0, _getPrototypeOf2.default)(SubmitButton)).apply(this, arguments));
  }

  (0, _createClass3.default)(SubmitButton, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          text = _props.text,
          submitting = _props.submitting,
          disabled = _props.disabled;

      return _react2.default.createElement(
        "div",
        { className: "submit-button-container" },
        _react2.default.createElement(
          "button",
          {
            type: "submit",
            className: "button",
            disabled: submitting || disabled
          },
          _react2.default.createElement(
            "span",
            { className: "button-text" },
            text
          )
        ),
        this.renderSpinner()
      );
    }
  }, {
    key: "renderSpinner",
    value: function renderSpinner() {
      if (this.props.submitting) {
        return _react2.default.createElement(_Spinner2.default, { additionalClasses: "mp-spinner-submit" });
      }
    }
  }]);
  return SubmitButton;
}(_react.Component), _class.propTypes = {
  text: _react.PropTypes.string.isRequired,
  submitting: _react.PropTypes.bool.isRequired,
  disabled: _react.PropTypes.bool
}, _temp);
exports.default = SubmitButton;
module.exports = exports["default"];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/form/SubmitButton.js
 ** module id = 41
 ** module chunks = 0
 **/